var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f;opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.54,88.63a6.37,6.37,0,0,1-4.49-1.92L9.17,58.83a4,4,0,0,1,5.66-5.66L41.11,79.46,80.52,10a4,4,0,1,1,7,3.94L47,85.37a6.3,6.3,0,0,1-4.61,3.2A5.52,5.52,0,0,1,41.54,88.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.3059b80d0ff5912bc2cc1cc953a90ff9.svg";
export { ForwardRef as ReactComponent };